export default __webpack_public_path__ + "static/media/camping_2.f831aa1a.jpg";